import React from "react";
import SideBar from "./SideBar";
import InterfacialImage from "../../Images/1_Interfacial.jpg";

const InterfacialPhenomenaAndNanoconfinement = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar interfacial={true} />
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5">
            Interfacial Phenomena and Nanoconfinement
          </div>
          <hr />
          <div className="row">
            <div className="col-md-7">
              <p className="mb-auto textAlign">
                Understanding the microscopic structure and dynamic properties
                of pure and complex fluids in the presence and absence of an
                external field is essential because of its various applications
                in energy, environment, and health. We investigate the behavior
                of water and ethanol-water mixtures under hydrophobic and
                hydrophilic surfaces. We perform extensive molecular dynamics
                simulations to understand molecular level insights into the
                factors affecting the wetting transition of fluids on the
                various substrate. The finding could be helpful in improving the
                design of surfaces, materials, and surfactant molecules for
                energy conversion, nanofluidics, lubrication, biological
                processes, and nanotechnological applications.
              </p>
            </div>
            <div className="col-md-5 text-center">
              <div className="card-text mb-auto research p-3">
                <img src={InterfacialImage} alt="" />
              </div>
            </div>
          </div>
          <div className="heading mt-4">Related Publications</div>
          <hr />
          <div className="mb-4 textAlign">
            <li className="mb-1">
              Manish Maurya, Atanu K. Metya, Jayant K. Singh, and Shinji Saito,
              &nbsp;<a
                className="remove-underline"
                href="https://doi.org/10.1063/5.0046817"
                target={"_blank"}
              >
                <font color="808000">
                  "Effects of interfaces on structure and dynamics of water
                  droplets on a graphene surface: A molecular dynamics study".
                </font>
              </a>
              <font color="008080">J. Chem. Phys. (2021), 154,164704.</font>
            </li>
            <li className="mb-1">
              Arnab Bose, Atanu K. Metya and Jayant K. Singh,
              &nbsp;<a
                className="remove-underline"
                href="https://doi.org/10.1039/C5CP03778F"
                target={"_blank"}
              >
                <font color="808000">
                  "Surface Effect on Electromelting Behavior of Nanoconfined
                  Water".
                </font>
              </a>
              <font color="008080">
                Phys. Chem. Chem. Phys. (2015), 17, 23147–23154.
              </font>
            </li>
            <li className="mb-1">
              Atanu K. Metya, Sandip Khan and Jayant K Singh,
              &nbsp;<a
                href="https://doi.org/10.1021/jp4096437"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Wetting Transition of Ethanol-Water Droplet on Smooth and
                  Textured Surfaces".
                </font>
              </a>
              <font color="008080">
                J. Phys. Chem. C (2014), 118, 4113–4121.
              </font>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterfacialPhenomenaAndNanoconfinement;
